<script>
import i18n from "../i18n";
import NotificationsApi from "@/services/notifications-api";
import SettingsApi from "@/services/settings-api";
import simplebar from "simplebar-vue";
import { horizontalMenuItems } from "./horizontal-menu";
import MegaMenu from "./mega-menu.vue"
import SearchMenu from "./search-menu.vue"
import GiftModal from '@/components/GiftModalComponent.vue';
import GiftApi from "@/services/gift-api";

// import MobileMegaMenu from "./mega-menu.vue";

import store from '@/state/store'


//import SupplierApi from "@/services/suppliers-api";
// import HorizontalNav from "@/components/horizontal-nav";


/**
 * Nav-bar Component
 */
export default {
  computed: {
    comparatorItems() {
        return this.$store.state.comparatorItems;
    },

    currentUser() {
        return store.getters['auth/currentUser'];
    },

    cartCount() {
      let cart = this.$store.state.cart;
      return cart ? cart.count : 0;
    },

    comparatorCount() {
      return  this.$store.state.comparatorItems ?  this.$store.state.comparatorItems.length : 0;
    },

    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },

    userShortName() {
      var short = this.currentUser.fullName ? this.currentUser.fullName.split(' ')[0] : '';
      return short.length > 7 ? short.substring(0, 7) + '...' : short;
    },

    userFullName() {
      return this.currentUser && this.currentUser.fullName ? this.currentUser.fullName : '';
    },

    isSupplier() {
      return this.currentUser && this.currentUser.role == "SUPPLIER";
    },

    isAdmin() {
      return this.currentUser && this.currentUser.role == "ADMIN";
    },

    role() {
      return this.currentUser ? this.currentUser.role : null;
    },






  },
  data() {
    return {
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      keyword: "",
      supplierFullName: '',

      interval: null,

      notifications: [],
      notificationsCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      showDraftOrder: false,

      menuItems: horizontalMenuItems,
      showDropdown: false,
      showMobileDropdown: false,

      showSearch: false,
      showSearchTransitionEnd: false,

      headerSettings: null,

      countUnviewedNotif:null,

      logoImg: require("@/assets/images/logo.png"),

      showGiftModal: false,
      gift:null,
      giftWinner: { id: null, name:null, phone:null, email:null },

      modalCode: null,

    };
  },
  components: { simplebar/*, HorizontalNav*/,  MegaMenu/*, MobileMegaMenu*/, SearchMenu, GiftModal },
  created() {
    this.getNotifications() // first run
    this.interval = setInterval(this.getNotifications, 30000)

    this.checkGift() // first run
    this.interval = setInterval(this.checkGift, 5000)
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;


    //this.hideTopBarOnScroll();

    this.getHeaderSettings();


  },
  methods: {

    handleCloseGiftWinner(){
      this.showGiftModal = false
    },

    checkGift(){
      
      const giftCode = this.$store.state.giftCode;
      if(!giftCode || giftCode =='undefined' ){
        return
      }

      GiftApi.checkGift(giftCode).then((gift)=>{
      if(gift){
        this.gift = gift
        this.showGiftModal = true
        this.modalCode = giftCode;
        this.$store.commit('setGiftCode', null);


      }
    })
    },

    setIsViewed(notif){
      notif.isViewed = true
      NotificationsApi.setIsViewed(this.notifPage - 1, this.notifPageSize ,notif.id)
      .then(notif => {
          if (notif) {
            this.notifications = notif.notifications;
            this.notificationsCount = notif.count;
            this.countUnviewedNotif = notif.countUnviewedNotif;

          }
        })

    },

    getHeaderSettings(){

       if (this.$route.name != 'default') {
        return;
       }

        const itemSectionId = this.$store.state.mainSectionId
        SettingsApi.getHeaderSettings(itemSectionId)
        .then(result => {
          if(result){
            this.headerSettings= result
            
          }
        })
    },

    changeLogo() {
      this.logoImg = require("@/assets/images/logo-mini-orange.png");
    },

    restoreLogo() {
      this.logoImg = require("@/assets/images/logo.png");
    },



    // hideTopBarOnScroll() {

    //   if (this.$route.name != 'default') {
    //     return;
    //   }

    //   var prevScrollpos = window.pageYOffset;
    //   var element = document.getElementById("black-header-bar");
    //   window.onscroll = function() {
    //     var currentScrollPos = window.pageYOffset;
    //     if (prevScrollpos > currentScrollPos) {
    //       //element.classList.remove("d-none");
    //       element.classList.add("d-lg-flex");
    //     } else {
    //       element.classList.remove("d-lg-flex");
    //       //element.classList.add("d-none");
    //     }
    //     prevScrollpos = currentScrollPos;
    //     if (currentScrollPos === 0) {
    //       //element.classList.remove("d-none");
    //       element.classList.add("d-lg-flex");
    //     }
    //   }
    // },


    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    search() {
      this.$router.push({ name: 'catalog', query: { filter: this.keyword } })
    },

    getNotifications() {

      if (!this.currentUser) {
        return;
      }

      NotificationsApi.getNotifications(this.notifPage - 1, this.notifPageSize)
        .then(notif => {
          if (notif) {
            this.notifications = notif.notifications;
            this.notificationsCount = notif.count;
            this.countUnviewedNotif = notif.countUnviewedNotif;

          }
        })
    },


    toPath(notificationType) {
      if (notificationType == null) {
        return;
      }
      if (notificationType == 0 || notificationType == 1 || notificationType == 2 || notificationType == 3) {
        return '/orders/order'
      }

      if (notificationType == 4) {
        return '/invoices/list'
      }
    },

    toQuery(notif) {
      if (notif == null) {
        return;
      }
      if (notif.type == 0 || notif.type == 1 || notif.type == 2 || notif.type == 3) {
        return notif.orderId
      }

      if (notif.type == 4) {
        return null
      }
    },

    connect() {
      if (!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    toggleDropdownMethod(isShopItem) {
      if (isShopItem) {
        this.showDropdown = !this.showDropdown;
        
        if (this.showDropdown) {
          this.showSearch = false;
        }
      }
    },

    toggleSearchMethod() {
        this.showSearch = !this.showSearch;

        if (this.showSearch) {
          this.showDropdown = false;
        }
    },

    closeSearchMethod() {
      this.showSearch = false;
    },

    closeDropdownMethod() {
      this.showDropdown = false;
    },

    /*showMobileDropdownMethod() {
      this.showMobileDropdown = true;
    },

    hideMobileDropdownMethod() {
      this.showMobileDropdown = false;
    },*/

    beforeEnter(el) {
      el.style.height = '0px';
      this.showSearchTransitionEnd=false;
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave(el) {
      el.style.height = '0px';
      this.showSearchTransitionEnd=false;
    },
    afterEnter() {
      this.showSearchTransitionEnd=true;
    },

      },

  watch: {

    '$route.query.filter': {
      handler: function (filter) {
        this.keyword = filter;
      },
      deep: true,
      immediate: true
    },

    '$store.state.mainSectionId': {
            handler() {
              
              this.getHeaderSettings();
              //this.getSettingsBanner();

            },
            deep: true,
        },

    role: function () {

    },





  }




};
</script>

<style scoped>
/* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */


.navbar-header .mobile-user-button .dropdown .dropdown-menu {
  left: 10px !important;
  right: 10px !important;
  min-width: 300px;
}

@media all and (max-width: 1024px) and (min-width: 1024px) {
  #logo {
    padding-left: 20px;
  }

}



.menu {
  overflow-x: scroll;
  overflow-y: hidden;
  /* hide vertical scrollbar */
  white-space: nowrap;
  width: 100%;
  height: 100%;
  /* set height to fill the parent container */
  -ms-overflow-style: none;
  /* hide scrollbar on Edge */
  scrollbar-width: none;
  /* hide scrollbar on Firefox */
  -webkit-overflow-scrolling: touch;
  /* enable smooth scrolling on iOS */

  max-width: 630px;
  margin: auto;

}

.menu::-webkit-scrollbar {
  display: none;
  /* hide scrollbar on Chrome and Safari */
}

.menu:active {
  cursor: grab;
  cursor: -webkit-grab;
}

.menu:active::-webkit-scrollbar-thumb {
  background-color: #ddd;
}

.menu:active::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.menu ul {
  display: flex;
  /* use flexbox to make menu items expand to fill available space */
  align-items: stretch;
  /* stretch menu items to the full height of the menu */
}

.menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}


.menu li.active a,
.menu li a:hover {
  transform: scale(1.05);
}

.menu li.active,
.menu li:hover {

}


.menu li a {
  display: flex;
  /* enable flexbox layout */
  align-items: center;
  /* center link content vertically */
  justify-content: center;
  /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
}

menu ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.roll-down-enter-active, .roll-down-leave-active {
    transition: height 0.5s ease-in-out;
    overflow: hidden;
  }

  .roll-down-enter, .roll-down-leave-to {
    height: 0;
  }

  .roll-down-enter-to, .roll-down-leave {
    height: auto;
  }


</style>

<template>
   
  <div style="position: relative; z-index:999 !important;">

    
    <div class="navbar-header" >

      <header id="page-topbar">

        <!-- BLACK HEADER BAR -->
        <div v-if="headerSettings && headerSettings.topHeaderText" id="black-header-bar"
          :class="this.$route.name === 'default' ? '' : 'd-none d-lg-none'"
          class="row bg-dark text-uppercase text-white   p-1 ">

          <div class="col-12 text-center">

            <span class="text-white font-weight-bold" style="
                text-align: center;
                font-feature-settings: 'clig' off, 'liga' off;

                /* Button/XSmall */
                font-family: Space Grotesk;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px; /* 171.429% */">{{ headerSettings.topHeaderText }}</span>
          </div>

        </div>

        <!-- LOGO BLOCK & MOBILE MENU BUTTON & SEARCH INPUT (desktop search) -->
        <div  class="navbar-header">


          <div class="row w-100 m-sm-4 m-0">

            <div class="col-1 col-md-6 col-lg-6 col-xl-3 col-xxl-3" style="z-index:9999999">
              <div class="d-flex mobile-user-button">

                <!-- MAIN LOGO -->
                <img class="ml-2 mr-2 d-xl-none" alt="" style="cursor:pointer;"
                  :src="require('@/assets/images/fi-rr-align-right.svg')" @click="toggleDropdownMethod(true)" />
                <div class="my-auto">
                  <router-link to="/" class="logo logo-light  " id="logo">
                    <!-- Display the icon only on mobile screens -->
                    <span class="logo-sm">
                      <img class="ml-2" :src="logoImg" alt height="23" />
                    </span>
                    <span class="logo-lg">
                      <img :src="logoImg" @mouseover="changeLogo"
                          @mouseout="restoreLogo" alt height="30" />
                    </span>
                  </router-link>
                </div>

              </div>

            </div>

            <div class="col-0 col-md-0 col-lg-0 col-xl-6 col-xxl-6 d-none d-xl-block my-auto"
              style="margin-top: 0px !important;margin-bottom: 0px !important;">

              <div class="my-auto" style="height:100%;">
               

                <!-- END LOGO BLOCK -->


                <!-- MENU ITEMS -->
                <div class="menu">
                  <ul style="margin:0px;height:100%;">
                    <template v-for="(item, index) of menuItems">



                      <li :class="$route.name != 'default' && $route.path == item.link ? 'active' : ''" :key="index"
                        v-if="item.role == role || (!role && item.role == 0)"
                        @click="toggleDropdownMethod(item.label == 'Shop')" >                          
                          
                          <a class="text-dark font-weight-normal" :href="item.link ? item.link : 'javascript:void(0);'">
                            <!-- <img v-if="item.label == 'Accueil'" class="mr-2" src="@/assets/icons/home.svg" /> -->
                            <div v-if="item.label == 'Shop'">{{ $t(item.label) }}</div>
                            <div v-else>{{ $t(item.label) }}</div>
                            <img v-if="item.label == 'Shop'" class="ml-2" src="@/assets/icons/chevron-down.svg" />
                          </a>

                      </li>
                    </template>
                  </ul>
                </div>





              </div>

            </div>

            <div class="col-11 col-md-6 col-lg-6 col-xl-3 col-xxl-3 text-right">
              <!-- NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON + MOBILE SEARCH ICON -->
              <div class="">

                <!-- SEARCH BUTTON -->
                <div class="dropdown b-dropdown btn-group">

                  <button type="button" class="btn header-item noti-icon p-2 m-0" @click="toggleSearchMethod()">

                    <img src="@/assets/icons/search.svg" />
                  </button>
                </div>
                <!-- END SEARCH BUTTON -->


                <!-- COMPARE  BUTTON -->
                <div class="dropdown b-dropdown btn-group">
                  <router-link to="/comparateur">
                  <button type="button" class="btn header-item noti-icon p-1 m-0" :disabled = "comparatorItems.length  == 0">
                    <span style="border-radius: 45%; border: 1.5px solid #1F1E1E; background: #fff; padding-left: 6px; padding-right:6px; padding-top:3px;padding-bottom:5px;
                                justify-content: center; align-items: center; gap: 10px;">
                      <img src="@/assets/icons/compare.svg"  />
                    </span>
                    <span class="badge badge-dark font-size-12 " style="margin-left: -5px;" :class="comparatorItems.length  == 0 ? 'd-none'  : ''">{{ comparatorItems.length }}</span>
                  </button>
                  </router-link>
                </div>
                <!-- END COMPARE BUTTON -->

                <!-- NOTIFICATIONS BUTTON -->
                <b-dropdown v-if="currentUser" right  menu-class="dropdown-menu-lg p-1 m-0" toggle-class="header-item noti-icon"
                  variant="black">
                  <template v-slot:button-content>
                   <!--  <i class="bx bx-bell text-dark" style="font-size:28px;"></i> -->
                    <img src="@/assets/icons/bell.svg" >

                    <span class="badge badge-dark font-size-12 " :class="countUnviewedNotif == 0 ? 'd-none' : ''">{{ countUnviewedNotif > 99  ?  '+99' : countUnviewedNotif }}</span>
                    

                  </template>

                  <div class="p-3">
                    <div class="row align-items-center">
                      <div class="col">
                        <h6 class="m-0 font-weight-bold text-dark" style="letter-spacing:2px;">Notifications</h6>
                      </div>
                      
                    </div>
                  </div>
                  <simplebar style="max-height: 230px;">

                    <div v-for="notif in notifications" :key="notif.id">
                        <a href="javascript: void(0);" class="text-reset notification-item" @click="setIsViewed(notif)">
                          <div class="media">                          
                            <div class="media-body">
                              <h6 class="mt-0 mb-1 font-size-14 " :class="notif.isViewed ? 'text-secondary' : ' text-dark  font-weight-bold '">{{ notif.message }}</h6>
                              <div class="font-size-12 text-muted">

                                <p class="mb-0"   :class="notif.isViewed ? 'text-secondary' : ' text-dark  font-weight-bold '">
                                  {{ notif.date }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>

                    </div>

                    <div v-if="!notifications || !notifications.length">
                        <div class="row">
                          <div class="col-12 text-center">
                            <span class="text-muted text-light p-4">Pas de notifications</span>
                          </div>
                        </div>
                        
                    </div>

                  </simplebar>
                  <div class="p-2 border-top">
                    <div class="row">

                      <div class="col-2">
                        <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage <= 1 ? 'd-none' : ''"
                          @click="notifPage--; getNotifications();" href="javascript:void(0)">
                          <img   alt=""  width="18px" src="../assets/icons/fi-rr-angle-double-small-left.svg"  />  
                        </a>

                      </div>

                      <div class="col-8 text-center pt-1">
                        <span class="mr-2 ml-2 text-muted font-weight-bold" :class="notifPage == 1 ? 'd-none' : ''">Page
                          {{ notifPage }}</span>
                      </div>

                      <div class="col-2">
                        <a class="btn btn-sm btn-light btn-block text-center"
                          :class="notifPage >= notifPagesNbr ? 'disabled' : ''" href="javascript:void(0)"
                          @click="notifPage++; getNotifications();">
                          <img   alt=""  width="18px" src="../assets/icons/fi-rr-angle-double-small-right.svg"  />  


                        </a>

                      </div>

                    </div>

                  </div>
                </b-dropdown>
                <!-- END NOTIFICATIONS BUTTON -->




                <!-- USER BUTTON -->
                <div v-if="!currentUser" class="dropdown b-dropdown btn-group">
                  <router-link to="/login">
                    <button type="button" class="btn header-item noti-icon p-1 m-0" >
                      <span class=" p-2 text-dark"
                          :title="userFullName" style="font-size:16px;font-weight:bold;">
                          <router-link to="/login"> 
                            <img  src="@/assets/icons/user.svg" /> 
                          </router-link>
                          <img   v-if="userFullName && userShortName" alt="" width="18px" src="@/assets/icons/fi-rr-check.svg"  />  

                        </span>

                  </button>

                  </router-link>
                </div>
                <!-- END USER BUTTON -->

                <!-- USER BUTTON -->
                <b-dropdown v-if="currentUser" right  menu-class=" p-0 m-0" toggle-class="header-item noti-icon p-0 pr-1 m-0" style="left: 0px !important;
                right: 0px !important;"
                  variant="black">
                  <template v-slot:button-content>
                    <img src="@/assets/icons/user.svg" >
                    <img   v-if="userFullName && userShortName" alt="" width="18px" src="@/assets/icons/fi-rr-check.svg"  />  
                  </template>

                   <!-- espce client -->
                   <b-dropdown-item class="text-center" to="/espace-client">
                      <strong class="font-size-14 " style="letter-spacing: 2px;">
                        <img width="20px" src="@/assets/icons/user.svg" style="cursor:pointer;" class="mr-1" />
                        ESPACE CLIENT
                      </strong>
                  </b-dropdown-item>

                  
                  
                  <!-- wishlist -->
                  <b-dropdown-item class="text-center" to="/espace-client/wishlist">
                    
                      <strong class="font-size-14 text-uppercase" style="letter-spacing: 2px;">
                        <img width="15px" src="@/assets/icons/heart.svg" style="cursor:pointer;" class="mr-1 mb-1 " />
                        
                        WISHLIST
                      </strong>
                  </b-dropdown-item>

                  <b-dropdown-divider></b-dropdown-divider>

                   <!-- logout -->
                   <b-dropdown-item class="text-center mb-2" to="/logout">
                      <span class="font-size-14 text-uppercase" style="letter-spacing: 2px;">
                        Déconnexion
                      </span>
                  </b-dropdown-item>


                </b-dropdown>

                <!-- CART BUTTON -->
                <div class="dropdown b-dropdown btn-group">
                  <a href="/panier">
                    <button type="button" class="btn header-item noti-icon right-bar-toggle toggle-right p-0 pr-1 m-0">

                      <img src="@/assets/icons/bag.svg" />
                      <span class="badge badge-dark font-size-12 " :class="cartCount == 0 ? 'd-none' : ''">{{ cartCount }}</span>
                    </button>
                  </a>
                </div>
                <!-- END CART BUTTON -->

              </div>
              <!-- END NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON + MOBILE SEARCH ICON -->
            </div>


          </div>

        </div>



    <transition class="d-none d-lg-inline"
      name="roll-down"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave">
        <MegaMenu  v-if="showDropdown" @close="closeDropdownMethod"></MegaMenu>
    </transition>

    <!-- For mobile (without transition !!!) -->
    <MegaMenu class="d-lg-none" v-if="showDropdown" @close="closeDropdownMethod"></MegaMenu>

    <transition
      name="roll-down"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
      @after-enter="afterEnter"
    >
        <SearchMenu v-show="showSearch" :showSearch="showSearch && showSearchTransitionEnd" @close="closeSearchMethod" ></SearchMenu>
    </transition>


      </header>









      <!-- <HorizontalNav /> -->



      



    </div>

    <GiftModal v-if="gift"
        :showGiftModal="showGiftModal" 
        :gift="gift"  :modalCode="modalCode"
        :showForm="!(gift.isOrder || userFullName)"
        :giftWinner="giftWinner"
        @close-gift-winner="handleCloseGiftWinner"

        />
    

    <!-- <MobileMegaMenu @hide-mobile-menu="hideMobileDropdownMethod"> v-if="showMobileDropdown"></MobileMegaMenu> -->
  
  </div>

</template>
